module.exports = __webpack_public_path__ + "static/img/res_3.bb7b4aa8.png";